// This file is used to provide type definitions for the icons only.
// It may miss some icons if baklava-icons package is not up to date.
// The icons are fetched from the cdn by bl-icon and this file is irrelevant.
// Refer to the bl-icon file for information on how the icons are used.
import icons, { BaklavaIcon } from "@trendyol/baklava-icons";

export type { BaklavaIcon };
export default icons;
